import { registerCalls } from './calls/register'
import type { TenantPluginRegister } from '@yeshuman/sdk'

export const register: TenantPluginRegister = (app) => {
  registerCalls(app)
  app.register({ guestMarketingShellBackground: true })
}

export const providesDomains = ['calls']
export const requiresProduct = '>=2.7,<3'
